export default "/images/brands-banner.png?cbec9a9a44052944eac4bd7db04dc3d3";